<template>
  <div
    :class="[{'child-item': parent}, {'lookup-item': lookup}, 'input-field']"
  >
    <el-form-item
      :label="label"
      prop="req"
      :class="{'is-required': required == 'Required'}"
      v-if="type != 'number'"
    >
      <el-input
        :type="type"
        v-model="model"
        :placeholder="placeholder"
        @input="changeText(model, qfid, controltype)"
      />
      <span
        class="error"
        v-if="showError"
      >
        {{ errorMsg }}
      </span>
    </el-form-item>
    <el-form-item
      :label="label"
      prop="req"
      v-if="type == 'number'"
      :class="{'is-required': required == 'Required', 'number-field': type == 'number'}"
    >
      <el-input-number
        :type="type"
        v-model="model"
        @change="changeText(model, qfid, controltype)"
        :min="0"
      />
      <span
        class="error"
        v-if="showError"
      >
        {{ errorMsg }}
      </span>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: "TextField",
  data () {
    return {
      model: null,
      value: '',
      modelName: null,
      errorMsg: '',
      showError: false
    };
  },
  props: {
    qfid: { type: String, default: () => { return null; } },
    parent: { type: Boolean, default: () => { return false; } },
    type: { type: String, default: () => { return ''; } },
    controltype: { type: String, default: () => { return ''; } },
    placeholder: { type: String, default: () => { return ''; } },
    postfix: { type: String, default: () => { return ''; } },
    label: { type: String, default: () => { return ''; } },
    flag: { type: String, default: () => { return ''; } },
    select: { type: String, default: () => { return ''; } },
    required: { type: String, default: () => { return ''; } },
    condition: { type: String, default: () => { return ''; } },
    lookup: { type: Boolean, default: () => { return false; } },
  },
  created () {
    this.errorMsg = this.$t('common.errors.required');
    this.model = this.modelName = this.qfid + '_' + this.postfix;
    this.model = this.select;
    if (this.type == 'number' && !this.select) {
      this.model = 0
    }
  },
  methods: {
    changeText(value, fid, type) {
      this.$set(this, 'showError', false);
      let data = {
        findingId: fid,
        findingType: type,
        yNResultFlag: '',
        findingValue: value.toString(),
        ClinicalLookupCode: ''
      }
      if (this.flag) {
        data.yNResultFlag = this.flag;
      }
      if (this.lookup) {
        data.yNResultFlag = 'Y';
        data.ClinicalLookupCode = value.toString();
      }
      this.$emit('passData', {
        data: data,
        condition: this.flag,
        model: this.modelName,
        required: this.required
      })
    },
  }
}
</script>
